import { Component, OnInit } from '@angular/core';

declare var require: any;

@Component({
  selector: 'app-videostreamer-list',
  templateUrl: './videostreamer-list.component.html',
  styleUrls: ['./videostreamer-list.component.css']
})

export class VideostreamerListComponent implements OnInit {
	
  works = require('../../../assets/data/data.json');
  private random_id;

  constructor() { }

  ngOnInit() {
    this.random_id =  Math.floor(Math.random() * this.works.length);
    
  }

}
